import { render, staticRenderFns } from "./InsuranceDetailPrice.vue?vue&type=template&id=574a5a94&"
import script from "./InsuranceDetailPrice.vue?vue&type=script&lang=js&"
export * from "./InsuranceDetailPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports